import React from "react";
import { inject, observer } from 'mobx-react'
import FontAwesome from 'react-fontawesome';
import {Holdable, defineHold} from 'react-touch';
import {Button, ButtonGroup, FormGroup} from "reactstrap";
import {Link, Redirect} from "react-router-dom";
import {Component} from "react/lib/ReactBaseClasses";
import CardListaStore from "../stores/CardListaStore";
import {extendObservable} from "mobx";
import _ from "lodash"
import PropTypes from 'prop-types';
import loading from '../../../assets/images/ajax-loader.gif';
import CardClick from "./CardClick";

const CardTouchHandler = (props) => {
    if (!props.hasOneSelected) {
        return <Holdable config={props.holdConfig} onHoldComplete={props.onClick} >
            <div>
                <CardClick quantidadeSelecionados={props.options.quantidadeSelecionados} botoes={props.options.botoes} >
                    {props.children}
                </CardClick>
            </div>

        </Holdable>
    } else {
        return <div onClick={props.onClick}>
            {props.children}
        </div>
    }
};

@inject("store")
@observer
export default class CardLista extends Component {
    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
        this.controller = this.props.controller;
        this.tabelaStore = this.props.store.tabelaStore;
        this.header = this.props.header;
        this.title = this.props.title;
        this.content = this.props.content;
        this.actions = this.props.actions;
        this.link = this.props.link;
        this.onChange = this.props.onChange;
        this.multiActions = this.props.multiActions;
        this.onCardClick = this.props.onCardClick;
        this.handleButtonClick = this.handleButtonClick.bind(this);

        this.toggleExtras = this.toggleExtras.bind(this);
        this.select = this.select.bind(this);

        this.controller = new CardListaStore(this.tabelaStore, this.onChange)
    }

    componentDidMount() {

        this.controller.lista = this.props.listaItens;
        this.controller.lista.map(card => {
            return extendObservable(card, {
                showExtras: false,
                isSelected: false
            });
        });

        this.onChange(this.controller.lista);

        this.controller.showExtras.push(false);
    }

    componentWillUnmount() {
        this.controller.showExtras = [];
    }

    toggleExtras(event, index) {
        event.stopPropagation();
        this.controller.toggleExtras(index);
    }

    select(index) {
        if(this.props.botoesMobileOnSelected && this.props.botoesMobileOnSelected.length > 0) {
            this.tabelaStore.onRowSelect(this.props.listaItens[index], this.props.keyField);
            this.appStore.minimizedSideBar = true;
            this.controller.showExtras[index] = false;
        }
    }

    stopPropagation(event) {
        let e = event;
        e.persist();
        if (!e) e = window.event;
        e.cancelBubble = true;
        if (e.stopPropagation) e.stopPropagation();
    }

    handleButtonClick(buttons) {
        const list =[];
        if(_.get(buttons, "props.children")) {
            buttons.props.children.map(m => {
                const elem = React.cloneElement(m, {
                    onClick: (...props) => {
                        if(m.props.onClick) {
                            m.props.onClick(...props)
                        }
                        this.stopPropagation(...props)
                    }
                });

                list.push(elem);
            });
        }

        return <div>{list}</div>;
    }

    render() {

        const cardList = [];
        if(this.props.listaItens) {
            for(let i=0; i< this.props.listaItens.length; i++) {
                const openClass = this.props.listaItens[i].showExtras ? "mobile-card-container card-open" : "mobile-card-container card-closed";

                const selectedClass = this.props.listaItens[i].isSelected ? "mobile-card selected" : "mobile-card";

                const hold = defineHold({updateEvery: 50, holdFor: 500});

                const icon = this.props.listaItens[i].isSelected ? <FontAwesome name="check" /> : <FontAwesome name="chevron-down" />;

                const botoes = this.handleButtonClick(this.props.botoesMobileCard(this.props.listaItens[i], i));

                const options = {
                    botoes: botoes,
                    quantidadeSelecionados: this.tabelaStore.selected.length,

                }

                cardList.push(
                    <CardTouchHandler key={i} hasOneSelected={this.tabelaStore.selected.length > 0} holdConfig={hold} onClick={() => this.select(i)} options={options}>
                        <div className={this.props.listaItens[i].showExtras && this.onCardClick ? "mobile-card-container card-open card-action" : this.props.listaItens[i].showExtras ? "mobile-card-container card-open" : this.onCardClick ? "mobile-card-container card-closed card-action" : "mobile-card-container card-closed"} >
                            <div className={selectedClass} >
                                <a className="card-selected"><FontAwesome name="check" /></a>
                                {this.props.extras && <a className="open-extras" onClick={(event) => this.toggleExtras(event, i)}>{icon}</a>}
                                {this.props.header && <span className="header">{this.props.header(this.props.listaItens[i])}</span>}
                                {this.props.title && <span className="title">{this.props.title(this.props.listaItens[i])}</span>}
                                {this.props.content &&
                                <div className="card-contents">
                                <span className="card-content">
                                {this.props.content(this.props.listaItens[i])}
                                </span>
                                </div>}
                                <ButtonGroup>{botoes}</ButtonGroup>
                            </div>
                            {this.props.extras &&
                            <div className="card-extras">
                                <span className="card-extra">{this.props.extras(this.props.listaItens[i])}</span>
                            </div>
                            }
                        </div>
                    </CardTouchHandler>
                )
            }
        }
        return (
            <div>
                {this.tabelaStore.selected.length > 0 &&
                <div className="mobile-toolbar">
                    <div className="back-button"><a onClick={() => this.controller.deselectAll(this.props.listaItens,this.props.keyField)}><FontAwesome name="arrow-left"/></a></div>
                    <span className="selected-counter">{this.tabelaStore.selected.length}</span>

                    {<div className="toolbar-buttons">
                        {this.props.botoesMobileOnSelected}
                    </div>}
                </div>
                }
                {this.props.botoesMobileTop && this.props.botoesMobileTop.length > 0 &&
                <FormGroup className="buttons-mobile-top-cards">
                    {this.props.botoesMobileTop}
                </FormGroup>
                }
                {this.props.listaItens && this.props.listaItens.length > 0 &&
                    <div>
                        {cardList}
                    </div>
                }
                {(!this.props.listaItens || this.props.listaItens.length < 1) &&
                    <span>Não há registros.</span>
                }
            </div>
        )
    }
}

export {CardLista}
